import { useState, useEffect } from 'react';

interface HeroProps {
  onNavigateToContact?: () => void;
}

export function Hero({ onNavigateToContact }: HeroProps) {
  const images = [
    'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/MainEntrance.jpeg',
    'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/dedicatedDesk.jpeg',
    'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/cafetria.jpeg',
    'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/Sunset_cowork.jpeg',
    'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/cabins.jpeg',
    'https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/Cut-plan.jpg'
  ];
  
  const [currentIndex, setCurrentIndex] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);
  return (
    <section className="relative bg-[#F1ECDC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="space-y-6 overflow-hidden">
            <h1 className="text-5xl md:text-6xl text-[#1F473E]">
              Work Better Together
            </h1>
            <p className="text-xl text-[#49685E]">
              Premium coworking spaces designed for productivity, collaboration, and growth. Join our community of innovators and entrepreneurs.
            </p>
            <div className="flex flex-row gap-2 sm:gap-4">
              <button 
                onClick={onNavigateToContact}
                className="flex-1 sm:flex-initial px-2 sm:px-8 py-2 sm:py-3 text-sm sm:text-base bg-[#1F473E] text-[#F1ECDC] rounded hover:bg-[#49685E] transition-colors shadow-lg shadow-[#1F473E]/20"
              >
                Get Started
              </button>
              <button 
                onClick={() => {
                  const element = document.getElementById('pricing');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="flex-1 sm:flex-initial px-2 sm:px-8 py-2 sm:py-3 text-sm sm:text-base border-2 border-[#1F473E] text-[#1F473E] rounded hover:bg-[#1F473E] hover:text-[#F1ECDC] transition-colors shadow-lg shadow-[#1F473E]/20"
              >
                View Pricing
              </button>
            </div>
            <div className="flex gap-4 md:gap-8 pt-4 flex-wrap">
              <div>
                <div className="text-2xl md:text-3xl text-[#1F473E]">50+</div>
                <div className="text-xs md:text-base text-[#49685E]">WorkSpaces</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl text-[#1F473E]">10K+</div>
                <div className="text-xs md:text-base text-[#49685E]">Members</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl text-[#1F473E]">24/7</div>
                <div className="text-xs md:text-base text-[#49685E]">Access</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl text-[#1F473E]">99%</div>
                <div className="text-xs md:text-base text-[#49685E]">Uptime</div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative h-[300px] md:h-[350px] rounded-lg overflow-hidden shadow-2xl shadow-[#1F473E]/20">
              {images.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Coworking space ${index + 1}`}
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                    index === currentIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              ))}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-colors ${
                      index === currentIndex ? 'bg-white' : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}